import React from "react"
import style from "./TextButton.module.scss"

export enum BUTTON_TYPE {
  PRIMARY = "orange",
  SECONDARY = "orange-outline",
  ACCENT = "blue",
  DANGER = "red",
  SUCCESS = "green",
}

const BUTTON_CLASSES = {
  [BUTTON_TYPE.PRIMARY]: style.primary,
  [BUTTON_TYPE.SECONDARY]: style.secondary,
  [BUTTON_TYPE.ACCENT]: style.accent,
  [BUTTON_TYPE.DANGER]: style.danger,
  [BUTTON_TYPE.SUCCESS]: style.success,
}

export type TextButtonProps = {
  label: string
  type: BUTTON_TYPE
  isSmall?: boolean
  customClass?: string
  isLoading?: boolean
  isDisabled?: boolean
  onPress?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

const TextButton = ({
  label,
  onPress,
  type,
  isSmall,
  isLoading,
  isDisabled,
  customClass,
}: TextButtonProps) => (
  <button
    onClick={onPress}
    className={`theme-button-yellow ${style.button} ${isSmall && style.small} ${
      isLoading && style.loading
    } ${customClass && customClass}`}
    disabled={isDisabled ?? false}
  >
    {/* The loading indicator shows over the label when isLoading and not disabled */}
    {!isDisabled && isLoading && (
      <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="8" />
      </svg>
    )}
    <span>{label}</span>
  </button>
)

export default TextButton
